import React from 'react';
import { motion } from 'framer-motion';

import { TitleBar } from '../atoms';

const pageVariants = {
  initial: { opacity: 0 },
  in: { opacity: 1 },
  out: { opacity: 0 },
};

interface Props {
  title: string | null;
  hideBackButton?: boolean;
  backButtonUrl?: string;
  fullWidth?: boolean;
  children: React.ReactNode;
}

export function Page({ title, hideBackButton, backButtonUrl, fullWidth, children }: Props) {
  return (
    <motion.div initial="initial" animate="in" exit="out" variants={pageVariants} className="absolute h-full w-full">
      {title !== null && <TitleBar title={title} hideBackButton={hideBackButton} url={backButtonUrl} />}
      <div className={`flex justify-center py-1 relative ${fullWidth ? 'px-0' : 'px-1'}`}>
        <div className={`flex flex-col w-full ${fullWidth ? 'items-stretch' : 'items-center'}`}>{children}</div>
      </div>
    </motion.div>
  );
}
